import React from 'react';
import { Row, Col, Skeleton } from 'antd';
import './CustomSkeleton.scss';

function CustomSkeleton() {
  return (
    <div className="custom-skeleton">
      <Row gutter={[8, 16]} className="row-container">
        <Col span={6} className="col-conatiner">
          <Skeleton
            active
            paragraph={{
              rows: 2
            }}
          />
        </Col>
        <Col span={6} className="sub-col-container">
          <Skeleton
            active
            paragraph={{
              rows: 2
            }}
          />
        </Col>
        <Col span={6} className="sub-col-container">
          <Skeleton
            active
            paragraph={{
              rows: 2
            }}
          />
        </Col>
        <Col span={6} padding="10px" height="100%" width="100%">
          <Skeleton
            active
            paragraph={{
              rows: 2
            }}
          />
        </Col>
      </Row>
    </div>
  );
}

export default CustomSkeleton;
